import { skipToken, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { formularioQueries } from '../queries';
import { formularioService } from '../services/formularioService';
import type { CorpoResposta, MinhaParticipacao } from '../types/Formulario';

export function useCampanhaAtiva(enabled = true) {
  return useQuery({ ...formularioQueries.ativa(), enabled });
}

export function useMinhaParticipacao(id: string) {
  return useQuery(formularioQueries.participacao(id));
}

export function usePaises(enabled: boolean) {
  return useQuery({ ...formularioQueries.paises(), enabled });
}

export function useEstados(enabled: boolean) {
  return useQuery({ ...formularioQueries.estados(), enabled });
}

export function useCidades(estadoId: number | null) {
  const q = formularioQueries.cidades(estadoId ?? 0);
  return useQuery(estadoId == null ? { ...q, queryFn: skipToken } : q);
}

/** Busca as cidades de um estado sob demanda (atalho do endereço oficial), com o mesmo cache da lista. */
export function useBuscarCidades() {
  const qc = useQueryClient();
  return (estadoId: number) => qc.fetchQuery(formularioQueries.cidades(estadoId));
}

export function useResponder(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (corpo: CorpoResposta) => formularioService.responder(id, corpo),
    // A resposta salva e a situação das escritas entram direto no cache: o formulário remonta com a nova versão.
    onSuccess: ({ resposta, escritasAxiis }) =>
      qc.setQueryData<MinhaParticipacao>(formularioQueries.participacao(id).queryKey, (old) =>
        old ? { ...old, resposta, escritasAxiis } : old,
      ),
  });
}

/** Recarrega a situação (409): o formulário passa a mostrar a versão gravada. */
export function useRecarregarParticipacao(id: string) {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: formularioQueries.participacao(id).queryKey });
}
